'use client'
import dynamic from "next/dynamic";

// import MainLayoutPage from "@/Layout/MainLayout";
const MainLayoutPage = dynamic(() => import('@/Layout/MainLayout'), {
  ssr: false
})

export default function MainLayout({ children }: Readonly<{ children: React.ReactNode; }>) {
  return (
    <MainLayoutPage>
      {children}
    </MainLayoutPage>
  );
}
